<script lang="ts">
  import { onMount } from 'svelte';

  import Jazzicon from '@metamask/jazzicon';

  export let wallet: string | null;
  export let width = 24;

  let div: HTMLDivElement;

  function updateJazzicon(address: string | null) {
    if (!address || !div) return;

    const child = Jazzicon(width, parseInt(address.slice(2, 10), 16));

    if (div.firstChild) {
      div.replaceChild(child, div.firstChild);
    } else {
      div.appendChild(child);
    }
  }

  onMount(() => {
    updateJazzicon(wallet);
  });

  $: updateJazzicon(wallet);
</script>

<div bind:this="{div}" class="flex"></div>
